import { MapPin } from "lucide-react";

export default function PropertyCard({ properties, selectedId, onSelect, onNew }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-4 card-crisp">
      <div className="flex items-center gap-2 mb-3">
        <MapPin className="w-4 h-4 text-[#FF5A00]" />
        <div className="font-heading font-bold">Property</div>
        <button
          onClick={onNew}
          className="ml-auto text-xs bg-zinc-900 text-white px-2 py-1 rounded"
          data-testid="new-property-btn"
        >
          + New
        </button>
      </div>
      {properties.length === 0 && (
        <div className="text-xs text-zinc-500">
          No property saved yet. Create one to reuse measurements later.
        </div>
      )}
      <div className="space-y-2">
        {properties.map((p) => (
          <button
            key={p.id}
            onClick={() => onSelect(p.id)}
            className={`w-full text-left border rounded-lg p-2 transition-colors ${
              selectedId === p.id ? "border-[#FF5A00] bg-orange-50" : "border-zinc-200 hover:border-zinc-400"
            }`}
            data-testid={`property-pick-${p.id}`}
          >
            <div className="text-sm font-medium truncate">{p.label || "Property"}</div>
            {p.address && <div className="text-xs text-zinc-500 truncate">{p.address}</div>}
          </button>
        ))}
      </div>
    </div>
  );
}
